<template>
    <div class="detailValue">
        <SampleValue
            :sample_value="typeof this.sampleValue === 'string' ? JSON.parse(this.sampleValue) : this.sampleValue"
            :scopeName="scopeName"
            :carrierName="keycode"
            :typeId="typeId"
        ></SampleValue>
    </div>
</template>

<script>
import SampleValue from '@/components/SampleValue/SampleValue.vue';
export default {
    props: ['sampleValue', 'keycode', 'scopeName', 'typeId'],
    data() {
        return {
            tempObj: {},
            humObj: {}
        };
    },
    mounted() {},
    components: {
        SampleValue
    },
    methods: {
        historyData(item) {
            let { href } = this.$router.resolve({
                path: '/historyData',
                query: {
                    tagId: item.no,
                    id: item.id,
                    probeValue: this.sampleValue,
                    carrierName: this.keycode,
                    scopeName: this.scopeName,
                    sensorWay: 'bind'
                }
            });
            let openWindow = window.open(href, '_blank', 'height=1080,width=1080,top=100,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');

            openWindow.onload = () => {
                openWindow.document.title = `${item.no}历史记录`;
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.detailValue {
    // padding: 10px;
    h3 {
        font-weight: bold;
    }
}

.flexContent {
    line-height: 30px;
    display: flex;
    justify-content: space-between;

    i {
        cursor: pointer;

        &:hover {
            color: red;
        }
    }

    span {
        &:not(:last-child) {
            flex: 1;
            text-align: left;
        }

        &:nth-of-type(3) {
            flex: 1.5;
        }
    }
}
</style>
